export type IBowtieLanguageToModal = {
    searchDataId: string
    searchPosition: {
        x: number
        y: number
    }
}

export type ISearchBarrierActionSetDataID = {
    type: 'SET_SEARCH_BARRIER_DATA_ID'
    payload: {
        newSearchDataId: string
    }
}

export type ISearchBarrierActionSetPosition = {
    type: 'SET_SEARCH_BARRIER_POSITION'
    payload: {
        newSearchPosition: {
            x: number
            y: number
        }
    }
}

export interface ISearchBarrierActionClear {
    type: 'CLEAR_SEARCH_BARRIER'
}

export type ISearchBarrierAction =
    | ISearchBarrierActionSetPosition
    | ISearchBarrierActionClear
    | ISearchBarrierActionSetDataID

const initialState: IBowtieLanguageToModal = {
    searchDataId: null,
    searchPosition: {
        x: null,
        y: null
    }
}

export function searchBarrierReducer(state = initialState, action: ISearchBarrierAction): IBowtieLanguageToModal {
    switch (action.type) {
        case 'SET_SEARCH_BARRIER_POSITION':
            return { ...state, searchPosition: action.payload.newSearchPosition }

        case 'SET_SEARCH_BARRIER_DATA_ID':
            return { ...state, searchDataId: action.payload.newSearchDataId }

        case 'CLEAR_SEARCH_BARRIER':
            return initialState

        default:
            return state
    }
}
